import React from "react";
import { TiTick } from "react-icons/ti";

const DeliveryStatus = ({ orderData , estimatedTime}) => {
  const steps = [
    {
      id: 1,
      label: "Pending",
      status: "pending",
      color: "#AF313D",
    },
    {
      id: 2,
      label: "Preparing",
      status: "preparing",
      color: "#C97C2A",
    },
    {
      id: 3,
      label: "Ready to Pickup",
      status: "completed",
      color: "#00AE1C",
    },
  ];

  // Function to determine if a step is ticked
  const isStepTicked = (stepStatus) => {
    return (
      orderData?.data?.orderHistory?.some(
        (history) =>
          history.orderStatus.toLowerCase() === stepStatus.toLowerCase()
      ) || false
    );
  };

  // Function to get the timestamp for a specific step
  const getStepTime = (stepStatus) => {
    const history = orderData?.data?.orderHistory?.find(
      (h) => h.orderStatus.toLowerCase() === stepStatus.toLowerCase()
    );
    return history?.updatedAt || history?.time; // Fallback to `time` if `updatedAt` is not available
  };

  return (
    <div className="flex items-center justify-center p-4 mb-16">
      <div className="relative flex w-[70%] items-center mx-auto">
        <div className="flex items-center w-full relative">
          {steps.map((step, index) => {
            const isTicked = isStepTicked(step.status);
            

            return (
              <React.Fragment key={step.id}>
                {/* Circle */}
                <div className="relative flex items-center justify-center">
                  <div
                    className={`lg:w-[27.09px] w-[8.22px] h-[7.88px] sm:w-[8.22px] sm:h-[7.88px] lg:h-[25.96px] md:w-[18.93px] md:h-[18.14px] rounded-full ${
                      isTicked ? `bg-[${step.color}]` : "bg-gray-300"
                    }`}
                    style={{
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    {isTicked && (
                      <span
                        className="absolute sm:text-[.5rem] text-[.5rem] sm:-top-3 -top-3 md:text-[1rem] md:-top-4 lg:text-[1.5rem] lg:-top-6"
                        style={{
                          left: "50%",
                          transform: "translateX(-50%)",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        <TiTick />
                      </span>
                    )}
                  </div>

                  {/* Content Below Circle */}
                  <div
                    className="absolute w-[150px] max-w-[200px] min-w-[100px]"
                    style={{
                      top: "100%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      textAlign: "center",
                      marginTop: "8px",
                    }}
                  >
                    <p className="lg:text-[21.24px] font-baloo font-medium text-[9.45px] sm:text-[9.45px] md:text-[14.84px] text-[#3E4954]">
                      {step.label}
                    </p>
                    {/* Show time only for the "Preparing" step */}
                    {/* {step.status === "preparing" &&  (
                      <p className="lg:text-[18px] text-[8px] sm:text-[8px] md:text-[12px] text-gray-500">
                       {estimatedTime && estimatedTime}
                      </p>
                    )} */}
                  </div>
                </div>

                {/* Line */}
                {index < steps.length - 1 && (
                  <div
                    className="lg:h-[8px] h-[2.43px] sm:h-[2.43px] md:h-[5.59px]"
                    style={{
                      flex: "1 1 auto",
                      backgroundColor:
                        step.status === "preparing"
                          ? isStepTicked("completed")
                            ? steps[index + 1].color // Show the "completed" color only if the next step is ticked
                            : "#D1D5DB" // Default gray
                          : isTicked
                          ? step.color
                          : "#D1D5DB",
                    }}
                  ></div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DeliveryStatus;
